import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as FormActionSvg } from '../../../../assets/icons/form-action.svg';
import { ReactComponent as LocationSvg } from '../../../../assets/icons/location.svg';
import { ReactComponent as LocationGreySvg } from '../../../../assets/icons/location-grey.svg';
import { Button, ConfigProvider, Flex, Typography } from 'antd';
import AddressFetcher from '../../../VehicleMonitoring/components/AddressFetcher';
import { HYPHEN, PAGE_KEYS } from '../../../../utilities/constants';
import { UserRolesAndPermissionsContext } from '../../../../context/UserRolesAndPermissionsContext';

const { Text } = Typography;
const PendingSOSCard = ({
  data,
  handleSoActionModalOpen,
  onTripDetailClick,
}) => {
  const { isViewOnly } = useContext(UserRolesAndPermissionsContext);
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Flex vertical gap={12}>
        <Text strong>
          {data?.trip_id || HYPHEN} | {data?.device_id || HYPHEN}
        </Text>
        <div></div>
        <Flex gap={8}>
          <Text style={{ minWidth: 'max-content' }}>Location:</Text>
          <Text
            style={{
              flexGrow: 1,
              color: 'var(--primary-border-color, #71767c)',
            }}
          >
            <AddressFetcher
              location={{
                latitude: data?.latitude,
                longitude: data?.longitude,
              }}
              title=""
              fontSize="0.75rem"
            />
          </Text>
        </Flex>
        <Flex gap={24} justify="flex-end">
          <Button
            className="sos-card-action-button"
            icon={data?.trip_id ? <LocationSvg /> : <LocationGreySvg />}
            onClick={() =>
              onTripDetailClick(
                data,
                data?.trip_id,
                data?.device_id,
                data?.anomaly_id
              )
            }
            disabled={!data?.trip_id}
          />
          {!isViewOnly(PAGE_KEYS.SAFETY_AND_ANOMALY_MONITORING) && (
            <Button
              className="sos-card-action-button"
              icon={<FormActionSvg />}
              type="primary"
              onClick={() => handleSoActionModalOpen(data)}
            />
          )}
        </Flex>
      </Flex>
    </ConfigProvider>
  );
};

PendingSOSCard.propTypes = {
  data: PropTypes.shape({
    trip_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    device_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    anomaly_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  handleSoActionModalOpen: PropTypes.func.isRequired,
  onTripDetailClick: PropTypes.func.isRequired,
};

export default React.memo(PendingSOSCard);
